import React, { Suspense } from 'react';
import * as actions from '../../redux/user/actions.user';
import * as orgActions from '../../redux/organization/actions.organization';
import store from '../../store';
import history from '../../history';
import MobileWarningBanner from '../banners/MobileWarningBanner/MobileWarningBanner';
import DataLoaderContainer from './DataLoaderContainer';
import BalanceBanner from '../banners/BalanceBanner/BalanceBanner';
import ConnectionBanner from '../banners/ConnectionBanner/ConnectionBanner';
import { alanDebugLocalInfo } from '../../services/mini/alanLogs';
import PageLoader from '../components/PageLoader/PageLoader';
import { routeInfo } from './../../routeInfo';


class AlanContainer extends React.Component {
    componentDidMount() {
        const currentLocation = this.props.children.props.location;
        const currentRoute = this.props.children.props.route;
        const currentPathname = currentLocation.pathname;
        const { action, code, error } = currentLocation.query;
        /**
         * decide where we should redirect to:
         * - to the login screen after login with Github account
         * - to the screen from where we linked Github account
         */

        if (currentPathname.indexOf(routeInfo.githubOauth.path) >= 0) {
            if (action === 'assign') {
                store.dispatch(actions.assignGithubAccount({ code }));
            } else if (action === 'repo') {
                store.dispatch(actions.assignGithubAccount({ code, repositoryAccess: true }));
            } else if (error) {
                store.dispatch(actions.redirectAfterGithubOauthError());
            } else {
                history.replace({
                    pathname: routeInfo.loginWithGithub.url(),
                    search: window.location.search,
                });
            }
        } else if (currentPathname.indexOf('planVerification') >= 0) {
            store.dispatch(actions.verifyPlan({ code }));
        } else if (currentPathname.indexOf('orgMemberVerification') >= 0) {
            store.dispatch(orgActions.verifyOrganizationMember({ code }));
        } else {
            if (!currentRoute.noAuthRequired) {
                alanDebugLocalInfo('authorise call');
                store.dispatch(actions.authorise());
            }
        }
    }

    render() {
        const openedInFrame = window.location !== window.parent.location;

        return <div className="alan-container">
            {openedInFrame ?
                <React.Fragment /> :
                <React.Fragment>
                    <ConnectionBanner />
                    <MobileWarningBanner />
                    <BalanceBanner />
                    <div className="alan-container_scroll">
                        <Suspense fallback={<PageLoader />}>
                            <DataLoaderContainer>
                                {this.props.children}
                            </DataLoaderContainer>
                        </Suspense>
                    </div>
                </React.Fragment>
            }
        </div>;
    }
}

export default AlanContainer;
